
const wysiwyg = () => {
  const paragraphs = document.querySelectorAll(".wysiwyg p");

  paragraphs.forEach(function(paragraph) {
      if (paragraph.innerHTML.trim() === "&nbsp;") { // Check if content is a non-breaking space
          paragraph.remove(); // Remove the paragraph element
      }
  });
  
}

export default wysiwyg;
